import React from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  ChartOptions,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import StatusBadge from "~/Pages/Process/components/StatusBadge";
import { Tooltip as PrimeTooltip } from "primereact/tooltip";
import { Skeleton } from "primereact/skeleton";

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

const ProcessStatusOverview = ({
  data,
  statusOption,
  statusCounts,
  loading,
}) => {
  const allZero = data?.datasets[0]?.data?.every((val) => val === -1);
  const options: ChartOptions<"doughnut"> = {
    cutout: "50%",
    responsive: true,
    layout: {
      padding: { top: 10, bottom: 10, left: 10, right: 10 },
    },
    plugins: {
      legend: { display: false },
      datalabels: {
        color: "#fff",
        backgroundColor: "#1F2937",
        borderRadius: 10,
        padding: { top: 4, bottom: 4, left: 7, right: 7 },
        formatter: (value, ctx) => (allZero ? 0 : value),
        anchor: "end",
        align: "end",
        offset: -16,
        font: { weight: "bold", size: 12 },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const value = context.raw;
            return `Number of Processes: ${allZero ? 0 : value}`;
          },
        },
      },
    },
  };

  return (
    <div className="process__status__overview">
      <PrimeTooltip target=".info-icon" />
      <p className="heading">
        Process Status Overview
        <i
          className="pi pi-info-circle info-icon"
          data-pr-tooltip="Processes filtered by 'Start Date' within period selected"
          data-pr-position="right"
        />
      </p>
      <div className="process__status__overview--chart">
        <div className="doughnut_chart">
          {allZero && !loading && <p>No Data</p>}
          <Doughnut data={data} options={options} />
        </div>
        <div className="flex flex-column justify-content-evenly">
          {statusOption?.map((item) =>
            !loading ? (
              <div key={item.code} className="flex items-center gap-2">
                <StatusBadge status={{ primary_color: item.primary_color }} />
                <span className="status_label">
                  {item.name} ({statusCounts?.[item.code] ?? 0})
                </span>
              </div>
            ) : (
              <Skeleton width="8rem" />
            ),
          )}
        </div>
      </div>
    </div>
  );
};

export default ProcessStatusOverview;
